'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.config(function () {
  var bundles = {
    clearText: 'Effacer',
    clearStatus: '',
    closeText: 'Fermer',
    closeStatus: 'Fermer sans modifier',
    prevText: '',
    prevStatus: 'Voir le mois précédent',
    nextText: '',
    nextStatus: 'Voir le mois suivant',
    currentText: 'Courant',
    currentStatus: 'Voir le mois courant',
    monthNames: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthNamesShort: ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'],
    monthStatus: 'Voir un autre mois',
    yearStatus: 'Voir un autre année',
    weekHeader: 'Sm',
    weekStatus: '',
    dayNames: ['Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'],
    dayNamesShort: ['Dim', 'Lun', 'Mar', 'Mer', 'Jeu', 'Ven', 'Sam'],
    dayNamesMin: ['Di', 'Lu', 'Ma', 'Me', 'Je', 'Ve', 'Sa'],
    dayStatus: 'Utiliser DD comme premier jour de la semaine',
    dateStatus: 'Choisir le DD, MM d',
    dateFormat: 'dd/mm/yy',
    firstDay: 1,
    initStatus: 'Choisir la date',
    isRTL: false
  };
  $.datepicker.regional['fr'] = bundles;
  $.datepicker.setDefaults($.datepicker.regional["fr"]);
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/i18n/datepicker/datepicker_fr.js
// module id = 2715
// module chunks = 13